module.exports = __webpack_public_path__ + "static/media/1_A1_08.1be4df19.png";